
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { LensFormValues } from "@/types/inventory";
import { useTranslation } from "@/hooks/useTranslation";
import { useState } from "react";

interface LensNotesFieldProps {
  form: UseFormReturn<LensFormValues>;
}

export function LensNotesField({ form }: LensNotesFieldProps) {
  const { t } = useTranslation();
  const [charCount, setCharCount] = useState(form.getValues("notes")?.length || 0);
  const maxChars = 100;

  return (
    <FormField
      control={form.control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('notes')}</FormLabel>
          <FormControl>
            <Textarea 
              placeholder={t('notes_placeholder')} 
              className="resize-none" 
              rows={3} 
              {...field} 
              value={field.value || ""}
              maxLength={maxChars}
              onChange={(e) => {
                // Limit to 100 characters
                const value = e.target.value;
                if (value.length <= maxChars) {
                  field.onChange(value);
                  setCharCount(value.length);
                }
              }}
            />
          </FormControl>
          <div className="text-xs text-muted-foreground text-right mt-1">
            {charCount}/{maxChars}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
